// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
._material-design-icon_ri18g_12 {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
._assistantContent_ri18g_20 {
  background-image: var(--color-border-assistant, linear-gradient(125deg, #7398FE 50%, #6104A4 125%));
  border-radius: var(--border-radius-container);
  padding: 2px;
}
._assistantContent__inner_ri18g_25 {
  background-color: var(--color-background-assistant, #F6F5FF);
  border-radius: calc(var(--border-radius-container) - 1px);
  color: var(--color-main-text);
  padding: calc(var(--border-radius-container) - 1px);
  height: 100%;
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/NcAssistantContent-Ban7n3Bg.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,mGAAmG;EACnG,6CAA6C;EAC7C,YAAY;AACd;AACA;EACE,4DAA4D;EAC5D,yDAAyD;EACzD,6BAA6B;EAC7B,mDAAmD;EACnD,YAAY;EACZ,WAAW;AACb","sourcesContent":["/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n._material-design-icon_ri18g_12 {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n._assistantContent_ri18g_20 {\n  background-image: var(--color-border-assistant, linear-gradient(125deg, #7398FE 50%, #6104A4 125%));\n  border-radius: var(--border-radius-container);\n  padding: 2px;\n}\n._assistantContent__inner_ri18g_25 {\n  background-color: var(--color-background-assistant, #F6F5FF);\n  border-radius: calc(var(--border-radius-container) - 1px);\n  color: var(--color-main-text);\n  padding: calc(var(--border-radius-container) - 1px);\n  height: 100%;\n  width: 100%;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
